/** Search param carrying an invite token onto the login/register pages. */
export const INVITE_PARAM = 'invite';

/**
 * Builds the `/login` or `/register` link that carries an invite through to the auth form.
 *
 * Two params, deliberately: `redirect` is the generic "where to go once signed in" every auth
 * page already honours, while `invite` is what the form itself reads to lock the email field
 * and bind the sign-up to this invitation.
 */
export function inviteAuthPath(page: 'login' | 'register', token: string): string {
  const redirect = `/accept-invite?token=${encodeURIComponent(token)}`;
  return `/${page}?${INVITE_PARAM}=${encodeURIComponent(token)}&redirect=${encodeURIComponent(redirect)}`;
}
